var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconExit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2154 30.4516C16.2154 29.5965 16.918 28.9032 17.7846 28.9032H30.3385C30.6273 28.9032 30.8615 28.6721 30.8615 28.3871L30.8615 3.6129C30.8615 3.32785 30.6273 3.09678 30.3385 3.09678L17.7846 3.09678C16.918 3.09678 16.2154 2.40354 16.2154 1.54839C16.2154 0.693239 16.918 0 17.7846 0H30.3385C32.3607 0 34 1.61755 34 3.6129V28.3871C34 30.3824 32.3607 32 30.3385 32H17.7846C16.918 32 16.2154 31.3068 16.2154 30.4516Z",
    fill: "#EB6424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.3024C0 19.4426 0.936757 20.3669 2.09231 20.3669H12.2525C12.3005 21.1007 12.3606 21.8339 12.4327 22.5662L12.4948 23.1963C12.5957 24.2208 13.6982 24.8344 14.639 24.3895C18.4635 22.5809 21.9259 20.1061 24.8594 17.0839L24.9221 17.0193C25.4809 16.4436 25.4809 15.5356 24.9221 14.9599L24.8594 14.8953C21.9259 11.8731 18.4635 9.39822 14.639 7.58967C13.6982 7.14481 12.5957 7.75836 12.4948 8.78287L12.4327 9.41296C12.3606 10.1453 12.3005 10.8785 12.2525 11.6123L2.09231 11.6123C0.93676 11.6123 0 12.5366 0 13.6768V18.3024Z",
    fill: "#EB6424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExit);
export default __webpack_public_path__ + "static/media/icon-Exit.2b2ee4a88f61ea368e6d43ea2a0cd352.svg";
export { ForwardRef as ReactComponent };